module.exports = __webpack_public_path__ + "static/media/MaintenaceIcon.f0119d26.svg";